import SpinIcon from "../SpinIcon";
import "./index.scss";
import {
  LoadingOutlined,
  CheckCircleFilled,
  ExclamationCircleFilled,
} from "@ant-design/icons";
const StatusTag = (props) => {
  const { data, isTag, progress } = props;
  let color = "#61D4AD";
  //0:未开始. 10:排队中.  20:核查中.  30:已完成.  40:已终止.  50:失败
  if (data.status === 10) {
    color = "#FEC054";
  } else if (data.status === 20) {
    color = "#0068B2";
  } else if (data.status === 0) {
    color = "#0068B2";
  } else if (data.status === 40) {
    color = "#535353";
  } else if (data.status === 50) {
    color = "#FE545F";
  }

  let icon = null;
  if (isTag) {
    if (data.status === 2) {
      color = "#FE545F";
      icon = <ExclamationCircleFilled color="#FE545F" />;
    } else if (data.status === 50) {
      color = "#FEC054";
      icon = <ExclamationCircleFilled color="#FEC054" />;
    } else if (data.status === 30 || data.status === 1) {
      color = "#61D4AD";
      icon = <CheckCircleFilled color="#61D4AD" />;
    } else {
      color = "#0068B2";
      icon = <ExclamationCircleFilled color="#0068B2" />;
    }
  }
  if (isTag) {
    return (
      <div style={{ color }} className="statusTagDiv">
        {icon}
        <span className="statusName" style={{ borderColor: color }}>
          {data?.status_name}
        </span>
        {data.status === 20 && (
          <SpinIcon style={{ marginLeft: "4px" }}></SpinIcon>
        )}
      </div>
    );
  }
  return (
    <span style={{ color }} className="statusTagDiv">
      {data?.status_name}
      {data.status === 20 && <SpinIcon style={{ marginLeft: "4px" }}></SpinIcon>}
      {progress !== undefined && data.status === 20 && (
        <span className="statusProgress">{(progress * 100).toFixed(0)}%</span>
      )}
    </span>
  );
};
export default StatusTag;
